import { FortemSDKError } from '../shared/errors';
const isJsonContentType = (contentType) => {
    const value = contentType?.toLowerCase();
    return value?.includes('application/json') || value?.includes('+json') || false;
};
export const parseErrorResponse = async (response) => {
    if (isJsonContentType(response.headers.get('content-type'))) {
        const json = (await response.json().catch(() => null));
        if (json?.success === false &&
            typeof json.error?.code === 'string' &&
            typeof json.error?.message === 'string') {
            return new FortemSDKError(json.error.message, json.error.code, response.status, json.error.detail);
        }
    }
    return new FortemSDKError(response.statusText || 'Request failed', 'HTTP_ERROR', response.status);
};
